import styled from 'styled-components';

export const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30vh;
`;
